module.exports = __webpack_public_path__ + "img/zhuansu3.gif";